let token

const getToken = () => token
const setToken = (value) => token = value

export {getToken, setToken}